export const heading = {
  fontFamily: "Outfit",
};
